import * as React from 'react';

import { MotivationPopupDesktop } from '../../components/MotivationPopup';
import { useMotivationPopup } from './hooks/useMotivationPopup';

export const MotivationPopupDesktopContainer: React.FC = () => {
  const { isVisible, handleClose, handleLogin, handleRegister } = useMotivationPopup();

  return (
    <MotivationPopupDesktop
      isVisible={isVisible}
      onClose={handleClose}
      onLogin={handleLogin}
      onRegister={handleRegister}
    />
  );
};
